import * as React from 'react';

import PropTypes from 'prop-types';

import {FunnelCloseStatusBar} from './funnel-close-status-bar';
import {FunnelNumberLabel} from './funnel-number-label';

export class FunnelCloseStatus extends React.Component {
    static propTypes = {
        wonLeads: PropTypes.shape({
            count: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }),
            amount: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }).isRequired,
            htmlUrl: PropTypes.string.isRequired,
        }).isRequired,
        lostLeads: PropTypes.shape({
            count: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }),
            amount: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }).isRequired,
            htmlUrl: PropTypes.string.isRequired,
        }).isRequired,
        cancelledLeads: PropTypes.shape({
            count: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }),
            amount: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }).isRequired,
            htmlUrl: PropTypes.string.isRequired,
        }).isRequired,
        reassignedLeads: PropTypes.shape({
            count: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }),
            amount: PropTypes.shape({
                value: PropTypes.number.isRequired,
            }).isRequired,
            htmlUrl: PropTypes.string.isRequired,
        }),
        displayType: PropTypes.oneOf(['count', 'amount']),
        showReassigned: PropTypes.bool.isRequired,
        isBlank: PropTypes.bool.isRequired,
    };

    render() {
        const wonLeadValue = this.props.wonLeads[this.props.displayType].value;
        const lostLeadValue = this.props.lostLeads[this.props.displayType].value;
        const cancelledLeadValue = this.props.cancelledLeads[this.props.displayType].value;
        const reassignedLeadValue = this.props.reassignedLeads[this.props.displayType].value;

        const wonLeadPercent = this.props.wonLeads[this.props.displayType].percent;
        const lostLeadPercent = this.props.lostLeads[this.props.displayType].percent;
        const cancelledLeadPercent = this.props.cancelledLeads[this.props.displayType].percent;
        const reassignedLeadPercent = this.props.reassignedLeads[this.props.displayType].percent;

        const maxClosedValue = 100; // Bars are sized by percent, 100% being the max

        return (
            <div className='ui-funnel-report__close__container'>
                <FunnelCloseStatusBar
                    name='Won'
                    count={wonLeadValue}
                    percent={wonLeadPercent}
                    maxCount={maxClosedValue}
                    htmlUrl={this.props.wonLeads.htmlUrl}
                    isBlank={this.props.isBlank}
                >
                    <FunnelNumberLabel
                        isBlank={this.props.isBlank}
                        json={this.props.wonLeads}
                        displayType={this.props.displayType}
                    />
                </FunnelCloseStatusBar>
                <FunnelCloseStatusBar
                    name='Lost'
                    count={lostLeadValue}
                    htmlUrl={this.props.lostLeads.htmlUrl}
                    percent={lostLeadPercent}
                    maxCount={maxClosedValue}
                    isBlank={this.props.isBlank}
                >
                    <FunnelNumberLabel
                        isBlank={this.props.isBlank}
                        json={this.props.lostLeads}
                        displayType={this.props.displayType}
                    />
                </FunnelCloseStatusBar>
                <FunnelCloseStatusBar
                    name='Cancelled'
                    count={cancelledLeadValue}
                    htmlUrl={this.props.cancelledLeads.htmlUrl}
                    percent={cancelledLeadPercent}
                    maxCount={maxClosedValue}
                    isBlank={this.props.isBlank}
                >
                    <FunnelNumberLabel
                        isBlank={this.props.isBlank}
                        json={this.props.cancelledLeads}
                        displayType={this.props.displayType}
                    />
                </FunnelCloseStatusBar>
                {this.props.showReassigned ? (
                    <FunnelCloseStatusBar
                        name='Reassigned'
                        count={reassignedLeadValue}
                        htmlUrl={this.props.reassignedLeads.htmlUrl}
                        percent={reassignedLeadPercent}
                        maxCount={maxClosedValue}
                        isBlank={this.props.isBlank}
                    >
                        <FunnelNumberLabel
                            isBlank={this.props.isBlank}
                            json={this.props.reassignedLeads}
                            displayType={this.props.displayType}
                        />
                    </FunnelCloseStatusBar>
                ) : undefined}
            </div>
        );
    }
}
